import { createStore } from 'vuex';
import autotopup from "@/store/modules/autotopup";
import subscriber from "@/store/modules/subscriber";
import invoice from "@/store/modules/invoice";

export default createStore({
  modules: {
    autotopup: autotopup,
    subscriber: subscriber,
    invoice: invoice
  },
  state: {
    errorMessage: '',
    successMessage: '',
    warningMessage: '',
    setErrorMessageCalled: 0,
    setWarningMessageCalled: 0,
    setSuccessMessageCalled: 0,
    activationToken: null,
    voucherAllowed: false,
    userDetail: null,
    loginCredentials: null,
    appVersion: '',
    loginRedirectName: '',
    lastTopupValue: ''
  },
  getters: {
    activationToken: state => {
      return state.activationToken;
    },
    loginCredentials: state => {
      return state.loginCredentials;
    },
    appVersion: state => {
      return state.appVersion;
    },
    userDetail: state => {
      return state.userDetail;
    },
    loginRedirectName: state => {
      return state.loginRedirectName;
    },
    voucherAllowed: state => {
      return state.voucherAllowed;
    },
    lastTopupValue: state => {
      if(state.lastTopupValue) {
        return state.lastTopupValue;
      } else {
        return '';
      }
    }

  },
  mutations: {
    initializeStore(state) {
      let userDetailFromLocalStorage = null as any;
      userDetailFromLocalStorage = localStorage.getItem("userDetail");
      if (userDetailFromLocalStorage != null) {
        try {
          state.userDetail = JSON.parse(userDetailFromLocalStorage);
        } catch(e) {
          // something is not right with userDetail, remove it and let user login again
          localStorage.removeItem("userDetail");
          state.userDetail=null;
        }
      }
      let lastTopupValue = localStorage.getItem("lastTopupValue");
      if(lastTopupValue) {
        state.lastTopupValue = lastTopupValue;
      }
    },
    setUserDetail(state, userDetail) {
      localStorage.setItem("userDetail", JSON.stringify(userDetail));
      state.userDetail = userDetail;
    },
    clearUserDetail(state) {
      localStorage.removeItem("userDetail");
      state.userDetail = null;
    },
    setErrorMessage(state, message: string) {
      state.errorMessage = message;
      state.setErrorMessageCalled += 1;
    },
    clearErrorMessage(state) {
      state.errorMessage = '';
    },
    setSuccessMessage(state, message: string) {
      state.successMessage = message;
      state.setSuccessMessageCalled += 1;
    },
    clearSuccessMessage(state) {
      state.successMessage = '';
    },
    setWarningMessage(state, message: string) {
      state.warningMessage = message
      state.setWarningMessageCalled += 1;
    },
    clearWarningMessage(state) {
      state.warningMessage = '';
    },
    setActivationToken(state, activationToken) {
      state.activationToken = activationToken;
    },
    clearActivationToken(state) {
      state.activationToken = null;
    },
    setLoginCredentials(state, loginCredentials) {
      state.loginCredentials = loginCredentials;
    },
    setAppVersion(state, newAppVersion) {
      state.appVersion = newAppVersion;
    },
    clearLoginCredentials(state) {
      state.loginCredentials = null;
    },
    setLoginRedirectName(state, loginRedirectName: string) {
      state.loginRedirectName = loginRedirectName;
    },
    setVoucherAllowed(state, voucherAllowed) {
      state.voucherAllowed = voucherAllowed
    },
    clearLoginRedirectName(state) {
      state.loginRedirectName = '';
    },
    setLastTopupValue(state, lastTopupValue) {
      state.lastTopupValue = lastTopupValue;
      localStorage.setItem("lastTopupValue", lastTopupValue);
    },
    clearLastTopupValue(state) {
      state.lastTopupValue = '';
      localStorage.setItem("lastTopupValue", '');
    },
    clearAllStoreData(state) {
      state.errorMessage = '';
      state.successMessage = '';
      state.warningMessage = '';
      state.activationToken = null;
      state.userDetail = null;
      state.loginCredentials = null;
      state.loginRedirectName = '';
      state.lastTopupValue = '';
      localStorage.clear();
    },
  },
  actions: {
  },
});
